import { bindServices } from '@/services/api';

import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';

const api = bindServices('configVariables');

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'variable',
  state: {
    newVariable: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    pagination: meta,
    select: 'id,internalName,type,initialValue',
    notSelectSearch: 'type',
    paramsView: {
      select: 'id,internalName,type,initialValue,created,updated,',
      expand: {
        userCreator: { select: 'fullName' },
        userModifier: { select: 'fullName' },
      },
    },
    paramsEdit: {
      select: 'id,internalName,type,initialValue',
    },
    view: false,
    orderBy: '',
    id: null,
    loadingItem: false,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'variable/paged',
          params: payload,
        });
        yield put({
          type: 'queryVariables',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewVariable({ payload }, { put }) {
      yield put({
        type: 'addVariable',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewVariable',
          payload,
        });
      }
    },

    *editItemVariable({ payload }, { call, put }) {
      try {
        const table = yield call(api.getById, {
          route: 'variable',
          id: payload.id,
          params: payload.params,
        });
        yield put({
          type: 'editVariable',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
      } catch (error) {
        /* */
      }
    },

    *saveNewVariable({ payload }, { call, put }) {
      try {
        const response = yield call(api.create, {
          route: 'variable',
          data: payload.data,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveVariable',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showVariablesForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *saveEditVariable({ payload }, { call, put }) {
      try {
        const response = yield call(api.update, {
          route: 'variable',
          data: payload.data,
        });
        yield put({
          type: 'global/showVariablesGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveVariable',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showVariablesForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        yield call(api.apiRoute, {
          route: `variable/${id}`,
          method: 'delete',
        });
        yield put({
          type: 'global/showVariablesGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveVariable',
          payload: {
            state: false,
            item: null,
            view: false,
          },
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: `global/modalConfirm`,
            state: false,
            id: null,
          });
          yield put({
            type: `global/showVariables${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },

    *showItemVariable({ view }, { put }) {
      yield put({
        type: 'showEditItemVariable',
        view,
      });
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },

    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
  },

  reducers: {
    queryVariables(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    addVariable(state, { payload }) {
      return {
        ...state,
        newVariable: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },

    editOrViewVariable(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    editVariable(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        newUserOnGroup: false,
      };
    },

    saveVariable(state, { payload }) {
      return {
        ...state,
        saveVariable: payload,
        newVariable: false,
        selectedItem: false,
      };
    },

    showEditItemVariable(state, { view }) {
      return {
        ...state,
        view,
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newVariable: false,
        selectedItem: null,
        view: null,
        orderBy: '',
        id: null,
      };
    },
  },
};

export default Model;
